import EmblaCarousel from 'embla-carousel';

window.EmblaCarousel = EmblaCarousel;
